module.exports = __webpack_public_path__ + "img/mullins-tree-village.b0a50c2e.jpg";